import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";

export const AI_SPEND_TOOLTIP = "Uses 1 of your account's AI requests.";

export function AiSpendIcon({ className }: { readonly className?: string }) {
  return <FontAwesomeIcon icon={faWandMagicSparkles} className={className} aria-hidden="true" />;
}
